export default class NotFoundView {
  constructor() {
    this.onBackHome = null;
  }

  async render() {
    return `
      <div id="page-404" class="page-content active">
        <div class="empty-state">
          <span class="material-symbols-rounded" aria-hidden="true">error_outline</span>
          <h3>Halaman Tidak Ditemukan</h3>
          <p>Maaf, halaman yang Anda cari tidak dapat ditemukan.</p>
          <button type="button" id="back-home-btn" class="post-submit" data-text_tip="Kembali ke beranda">
            <span class="material-symbols-rounded" aria-hidden="true">home</span>
            <span>Kembali ke Beranda</span>
          </button>
        </div>
      </div>
    `;
  }

  async afterRender() {
    const btn = document.getElementById('back-home-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        if (this.onBackHome) this.onBackHome();
      });
    }
  }

  setBackHomeHandler(handler) {
    this.onBackHome = handler;
  }

  cleanup() {}
}
